<template>
  <div class="ti-page-start py2">
    <div class="lg-section px3">
      <router-link :to="{name: 'admin-home', params: { id: objId }}" class="ti-link">
        🡸 Connect Admin
      </router-link>
    </div>
    <div class="lg-section px3">
      <h2 v-if="!loading" class="detail-header-title">
        Connect Enquiries: {{vendor.name}}
      </h2>
    </div>

    <template v-if="!loading">
      <div v-if="canAccess" class="lg-section px3 pt3">
        <template v-if="enquiries.length!=0">
          <table style="width:100%;">
            <thead>
              <tr>
                <th class="tbl-label">Date</th>
                <th class="tbl-label">Enquirer</th>
                <th class="tbl-label">Contacts</th>
                <th class="tbl-label">Technology</th>
                <th class="tbl-label">Sector</th>
                <th class="tbl-label">Message</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="enq in enquiries" :key="enq.id">
                <td class="tbl-value">{{enq.date}}</td>
                <td class="tbl-value">{{enq.name}}&lt;<strong>{{enq.email}}</strong>&gt;</td>
                <td class="tbl-value">
                  <div v-for="(contact, index) in enq.contactList" :key="index">
                    {{contact}}
                  </div>
                </td>
                <td class="tbl-value">{{enq.techLabel}}</td>
                <td class="tbl-value">{{enq.sectorLabel}}</td>
                <td class="tbl-value tbl-text-preview">
                  <Popper :options="{placement: 'bottom',
                                    modifiers: {offset: {offset: '0,4px'}}}">
                    <span slot="reference" class="">{{enq.message}}</span>
                    <div class="popper">
                      <div class="m2">
                        <pre>{{enq.message}}</pre>
                      </div>
                    </div>
                  </Popper>
                </td>
              </tr>
            </tbody>
          </table>
          <Paginate class="mt2 right-align"
                    :totalPages="pageInfo.totalPages"
                    :currentPage="pageInfo.currentPage"
                    @goPage="goPage">
          </Paginate>
        </template>
        <template v-else>
          <p class="ti-p">No enquiries</p>
        </template>
      </div>
      <div v-else class="lg-section px2 pt3"> <!-- !canAccess -->
        <div class="ml3 mb2">
          <div v-if="error">
            <span class="ti-message ti-message-alert">
              {{error}}
            </span>
          </div>
          <div v-else>
            <span class="ti-message ti-message-alert">
              You currently do not have permission to access this page.
            </span>
          </div>
        </div>
      </div>
    </template> <!-- if loaded -->
  </div>
</template>

<script>
import axios from 'axios';
import Popper from 'vue-popperjs';

import Paginate from '@/components/Paginate.vue';


export default {
  name: 'ConnectEnquiries',
  components: { Popper, Paginate },
  data() {
    return {
      loading: true, // first load of refMap
      canAccess: null,
      error: null,
      objId: this.$route.params.id,
      vendor: null,
      enquiries: null,
      pageInfo: null,
    };
  },

  computed: {
  },

  created() {
    this.goPage(1);
  },

  methods: {
    goPage(pageIndex) {
      const params = { page: pageIndex };
      axios.get(`/api/connect/${this.objId}/enquiries`, { params })
        .then((res) => {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          this.vendor = res.data.vendor;
          this.canAccess = res.data.canAccess;
          this.error = res.data.error;
          if (this.canAccess) {
            this.enquiries = res.data.enquiries;
            this.pageInfo = res.data.pageInfo;
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

table, th, td {
  border-collapse: collapse;
  border: 1px solid #BDBDBD;
}

.tbl-value {
  text-align: left;
}

.tbl-text-preview {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

</style>
